import FormattedMessage from 'I18n/components/FormattedMessage';
import Small from 'UIComponents/elements/Small';
import UIProgress from 'UIComponents/progress/UIProgress';
import { UsageLimitBannerTitle } from 'ui-addon-upgrades/ums/banner/UsageLimitBanner';
import { isMc0653UpgradeKey } from '../mc0653/mc0653Constants';
import { jsx as _jsx } from "react/jsx-runtime";
const LimitUsageBannerRow = ({
  upgradeConfig,
  limit,
  usage
}) => {
  const percentageOfUsageLimitUsed = typeof usage === 'number' && typeof limit === 'number' && limit !== 0 ? usage / limit * 100 : 0;
  if (isMc0653UpgradeKey(upgradeConfig.upgradeKey)) {
    const sendsRemaining = limit - usage;
    return /*#__PURE__*/_jsx("div", {
      "data-test-id": "limit-usage-banner-row",
      children: /*#__PURE__*/_jsx(UIProgress, {
        "aria-label": "Progress Bar",
        use: "warning",
        value: percentageOfUsageLimitUsed,
        descriptiveLabel: /*#__PURE__*/_jsx(Small, {
          style: {
            fontWeight: 500
          },
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "upgrades.mc0653.emailSendsCounter.popover.progressBar.sendsRemaining",
            options: {
              sendsRemaining
            }
          })
        }),
        valueLabel: /*#__PURE__*/_jsx(Small, {
          style: {
            fontWeight: 'normal'
          },
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "upgrades.mc0653.emailSendsCounter.popover.progressBar.emailsSent",
            options: {
              value: usage,
              limit
            }
          })
        })
      })
    });
  }
  return /*#__PURE__*/_jsx("div", {
    "data-test-id": "limit-usage-banner-row",
    children: /*#__PURE__*/_jsx(UIProgress, {
      value: percentageOfUsageLimitUsed,
      descriptiveLabel: /*#__PURE__*/_jsx(UsageLimitBannerTitle, {
        featureTranslationKey: upgradeConfig.featureTranslationKey || 'placeholder',
        value: usage,
        limit: limit
      })
    })
  });
};
export default LimitUsageBannerRow;